import React from 'react';
import PropTypes from 'prop-types';
import Spacer from '@deliveroo/consumer-component-library/components/Spacer';
import Button from '@deliveroo/consumer-component-library/components/Button';
import Heading from '@deliveroo/consumer-component-library/components/Heading';

import ResponsiveGridLayout from '../ResponsiveGridLayout';
import LocationLink from '../LocationLink';
import styles from './styles.scss';

export const INITIAL_MAX_LOCATIONS = 18;

export class LocationList extends React.Component {
  state = {
    hasMounted: false,
    isExpanded: false,
  };

  /**
   * Allow us to set CSS properties for some elements only after the page has
   * initially mounted.
   */
  componentDidMount() {
    this.setState({ hasMounted: true });
  }

  onClickViewAll = () => {
    this.setState({ isExpanded: true });
  };

  render() {
    const { locations, containerId, headerText, spacing, maxColumns } = this.props;

    const { hasMounted, isExpanded } = this.state;

    const showViewAll = hasMounted && !isExpanded && locations.length > INITIAL_MAX_LOCATIONS;
    const maxVisibleLocations = isExpanded ? locations.length : INITIAL_MAX_LOCATIONS;

    const viewAll = (
      <div className={styles.viewAll}>
        <Button type="secondary" size="small" onClick={this.onClickViewAll}>
          View all
        </Button>
      </div>
    );

    return (
      <div id={containerId}>
        <Spacer spacing={spacing}>
          <Heading
            level={2}
            size="x-small"
            spacing={{ mobile: '0 0 medium 0', tablet: '0 0 x-large 0' }}
          >
            <span className={styles.heading}>{headerText}</span>
          </Heading>
          <ResponsiveGridLayout gutter="medium" maxColumns={maxColumns} minColumnWidth={160}>
            {locations.map(({ name, url }, index) => {
              const location = <LocationLink key={`location-${url}`} url={url} name={name} />;

              if (!hasMounted || index < maxVisibleLocations) return location;

              return (
                <div className={styles.hidden} key={`hidden-location-${url}`}>
                  {location}
                </div>
              );
            })}
          </ResponsiveGridLayout>
          {showViewAll && viewAll}
        </Spacer>
      </div>
    );
  }
}

LocationList.propTypes = {
  locations: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    }),
  ),
  headerText: PropTypes.string.isRequired,
  containerId: PropTypes.string,
  spacing: PropTypes.string,
  maxColumns: PropTypes.number,
};

LocationList.defaultProps = {
  locations: [],
  containerId: 'location-list',
  spacing: 'x-large 0 0 0',
  maxColumns: 6,
};
